<template>
  <div class="content" @wheel="handleWheel">
    <first-screen ref="firstScreen" id="first-screen" />
    <competency-module
      ref="competencyModule"
      id="competency-module"
      class="competency-module"
    />
    <solution-module ref="solutionModule" id="solution-module" />
    <service-module ref="serviceModule" id="service-module" />
    <information-reported ref="informationReported" id="information-reported" />
    <div class="radio-dot-wrapper">
      <div
        v-for="(item, index) in idList"
        :key="index"
        class="radio-dot"
        :class="{
          active: item === current
        }"
        @click="handleSwitch(item)"
      ></div>
    </div>
    <img
      v-lazyload
      class="star-background no-right-click"
      :data-src="starlitSky"
      alt=""
      srcset=""
    />
  </div>
</template>

<script>
import FirstScreen from './components/FirstScreen.vue'
import CompetencyModule from './components/CompetencyModule.vue'
import SolutionModule from './components/SolutionModule.vue'
import ServiceModule from './components/ServiceModule.vue'
import InformationReported from './components/InformationReported.vue'
import starlitSky from '@/assets/images/starlitSky.svg'

export default {
  name: 'HomeIndex',
  components: {
    FirstScreen,
    CompetencyModule,
    SolutionModule,
    ServiceModule,
    InformationReported
  },
  data() {
    return {
      starlitSky,
      idList: [
        'first-screen',
        'competency-module',
        'solution-module',
        'service-module',
        'information-reported'
      ],
      current: 'first-screen',
      observer: null
    }
  },
  methods: {
    handleSwitch(id) {
      this.current = id
      document.getElementById(id).scrollIntoView({
        block: 'nearest',
        behavior: 'smooth'
      })
    },
    changeCurrent(deltaY) {
      const viewHeight = window.innerHeight
      let rect = this.$refs.firstScreen.$el.getBoundingClientRect()
      if (rect.top - deltaY < viewHeight && rect.top - deltaY > -rect.height) {
        this.current = 'first-screen'
        return
      }

      rect = this.$refs.competencyModule.$el.getBoundingClientRect()
      if (rect.top - deltaY < viewHeight && rect.top - deltaY > -rect.height) {
        this.current = 'competency-module'
        return
      }
      rect = this.$refs.solutionModule.$el.getBoundingClientRect()
      if (rect.top - deltaY < viewHeight && rect.top - deltaY > -rect.height) {
        this.current = 'solution-module'
        return
      }
      rect = this.$refs.serviceModule.$el.getBoundingClientRect()
      if (rect.top - deltaY < viewHeight && rect.top - deltaY > -rect.height) {
        this.current = 'service-module'
        return
      }
      rect = this.$refs.informationReported?.$el.getBoundingClientRect()
      if (rect.top - deltaY < viewHeight && rect.top - deltaY > -rect.height) {
        this.current = 'information-reported'
        return
      }
    },
    handleWheel(e) {
      const deltaY = e.deltaY
      this.changeCurrent(deltaY)
    }
  },
  mounted() {
    this.changeCurrent(0)
  }
}
</script>
<style lang="less" scoped>
.content {
  position: relative;
  .radio-dot-wrapper {
    position: fixed;
    width: 40px;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
    background-color: #33333333;
    border-radius: 20px;
    z-index: 9999;
    .radio-dot {
      margin: 12px;
      height: 16px;
      width: 16px;
      border: 3px solid #efefef33;
      border-radius: 50%;
      background-color: #333333;
      cursor: pointer;
      &.active {
        border-color: #ff1e3d;
      }
    }
  }
  .star-background {
    position: absolute;
    bottom: 0;
    width: 100%;
    z-index: -1;
  }
}
</style>
